import { Component, effect, inject, OnDestroy, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { IdleTimeoutModalComponent } from './core/components/idle-timeout-modal.component';
import { AuthService } from './core/services/auth.service';
import { IdleService } from './core/services/idle.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, IdleTimeoutModalComponent],
  template: `
    <router-outlet />

    @if (showIdleModal()) {
      <app-idle-timeout-modal (loginRequested)="onIdleLoginRequested()" />
    }
  `
})
export class AppComponent implements OnDestroy {
  private idleService = inject(IdleService);
  private authService = inject(AuthService);

  showIdleModal = signal(false);
  private idleSubscription?: Subscription;

  constructor() {
    // Monitorear estado de autenticación
    effect(() => {
      const isAuthenticated = this.authService.isAuthenticated();

      if (isAuthenticated) {
        // Usuario autenticado - iniciar monitoreo de inactividad
        this.startIdleMonitoring();
      } else {
        // Usuario no autenticado - detener monitoreo
        this.stopIdleMonitoring();
      }
    });
  }

  private startIdleMonitoring(): void {
    // Reiniciar el servicio de inactividad
    this.idleService.restart();

    // Suscribirse a eventos de inactividad
    if (!this.idleSubscription || this.idleSubscription.closed) {
      this.idleSubscription = this.idleService.onIdle.subscribe(() => {
        console.warn('[App] User idle timeout - showing session expired modal');
        this.showIdleModal.set(true);
      });
    }
  }

  onIdleLoginRequested(): void {
    // Ocultar el modal sincrónicamente antes de llamar logout(),
    // así el usuario ve feedback inmediato sin esperar el ciclo del effect()
    this.showIdleModal.set(false);
    this.authService.logout();
  }

  private stopIdleMonitoring(): void {
    // Detener el servicio de inactividad
    this.idleService.stop();

    // Cancelar suscripción
    if (this.idleSubscription) {
      this.idleSubscription.unsubscribe();
      this.idleSubscription = undefined;
    }

    // Ocultar modal si está visible
    this.showIdleModal.set(false);
  }

  ngOnDestroy(): void {
    this.stopIdleMonitoring();
  }
}
